import { useNotifications } from '@sequencehq/core-components'
import { useCallback } from 'react'

/**
 * Several flows need the customer's address and the backend rejects them
 * without one — starting a schedule, sending an invoice, sending a credit
 * note. They all say it in the same words, so an operator who meets this on an
 * invoice recognises it from the schedule and knows the fix is the same.
 *
 * `action` completes "Add an address to the customer before ...", e.g.
 * "sending this invoice".
 */
export const useMissingCustomerAddressToast = () => {
  const { displayNotification } = useNotifications()

  return useCallback(
    (action: string) => {
      displayNotification('This customer does not have an address', {
        type: 'error',
        description: `Add an address to the customer before ${action}.`
      })
    },
    [displayNotification]
  )
}
